import { debounce } from 'lodash-es';
import { useState, useEffect } from 'react';

function getBreakPoint(windowWidth) {
  if (windowWidth) {
    if (windowWidth <= 700) {
      return 'mobile';
    } else if (701 < windowWidth && windowWidth < 1024) {
      return 'tablet';
    } else if (windowWidth < 1025) {
      return 'desktop';
    }
  } else {
    return undefined;
  }
}

function useWindowSize(): string | undefined {
  const isWindowClient = typeof window === 'object';

  const [windowSize, setWindowSize] = useState(
    isWindowClient ? getBreakPoint(window.innerWidth) : undefined
  );

  useEffect(() => {
    const setSize = debounce(
      () => {
        setWindowSize(getBreakPoint(window.innerWidth));
      },
      300,
      {
        trailing: true,
        maxWait: 300
      }
    );

    if (isWindowClient) {
      window.addEventListener('resize', setSize);

      return () => window.removeEventListener('resize', setSize);
    }
  }, [isWindowClient, setWindowSize]);

  return windowSize;
}

export default useWindowSize;
